export const breakPoint2XL = 1536;
export const breakPointXL = 1280;
export const breakPointLG = 1024;
export const breakPointMD = 768;
export const breakPointSM = 640;
